import React, { useState } from 'react';
import cms from '@moka-fe/cms';
import { Avatar, Menu, Select, Tag } from 'sugar-design';
import * as sdf from '@SDFoundation';

import { getI18n } from '@/utils/i18n';

import styles from './index.cm.styl';

const i18n = getI18n();

export interface Option {
  managerId?: number;
  managerName?: string;
  managerEmail?: string;
}

const JobManagerSelect = ({
  value,
  options = [],
  onChange,
}: {
  value: Option['managerId'][];
  options: Option[];
  onChange: (value: Option['managerId'][]) => void;
}) => {
  const [searchKey, setSearchKey] = useState('');
  const tagsRender = (_options: Option[], onTagClose: (option: Option) => void) => {
    return _options.map((op) => {
      return (
        <Tag
          closeable
          onClose={onTagClose(op)}
          key={op.managerId}
          // eslint-disable-next-line react/forbid-component-props
          style={{ maxWidth: '95px' }}
          // @ts-ignore
          showTooltipWhenOverflow={{ appendBody: true }}
        >
          {op.managerName}
        </Tag>
      );
    });
  };

  const wrapKeyString = (string: string, inputValue: string) => {
    // 性能优化
    if (!inputValue) {
      return string;
    }
    return Select.getKeywordArr(string, inputValue, styles.searchActive);
  };

  const getOptionText = (option: Option, inputValue: string) => {
    const { managerName, managerEmail = '' } = option;

    return (
      <div className={sdf.n40}>
        <div className={styles.userCardName}>{wrapKeyString(managerName, inputValue)}</div>
        <div className={styles.userCardSubrowEmail}>{wrapKeyString(managerEmail, inputValue)}</div>
      </div>
    );
  };

  const optionRender = (
    option: Option,
    isSelect: boolean,
    inputValue: string,
    onClickHandler?: () => void
    // eslint-disable-next-line max-params
  ) => {
    return (
      <Menu.Item
        className={cms.cursorPointer}
        prefix={
          <Avatar className={styles.avatar} name={option.managerName || option.managerEmail} />
        }
        key={option.managerId}
        onClick={onClickHandler}
        isSelected={isSelect}
      >
        {getOptionText(option, inputValue)}
      </Menu.Item>
    );
  };

  return (
    <Select
      size="md"
      multiple
      clearable
      searchable
      maxLine={3}
      placeholder={i18n.t`请选择职位负责人`}
      valueKey="managerId"
      labelKey="managerName"
      value={value}
      options={
        searchKey
          ? options.filter(
              (option) =>
                Select.isIncludesKeyword(option.managerName || '', searchKey) ||
                Select.isIncludesKeyword(option.managerEmail || '', searchKey)
            )
          : options
      }
      tagsRender={tagsRender}
      optionRender={optionRender}
      onChange={onChange}
      onSearch={setSearchKey}
      optionFilter={() => true}
    />
  );
};

export default JobManagerSelect;
